export default __webpack_public_path__ + "static/media/buy_hbb_wfbb.42ac79ca.svg";